import { M8PaymentTransactionStatus } from 'services/production/types';
import { CardPaymentStatus } from 'types/state';

export const normalizeM8PaymentTransactionStatus = (
  status: M8PaymentTransactionStatus
) => ({
  toCardPaymentStatus(): CardPaymentStatus {
    return status;
  },
});
